export default {
    CREATE_POS_WORKSTATION_USER: 'create pos_workstation_user',
    VIEW_ALL_G_QUERY: 'view all g_query',
    VIEW_DETAIL_G_QUERY: 'view detail g_query',
    CREATE_G_QUERY: 'create g_query',
    EDIT_G_QUERY: 'edit g_query',
    DELETE_G_QUERY: 'delete g_query',
    EXECUTE_RUN_G_QUERY: 'execute run g_query',
    VIEW_ALL_G_MENU: 'view all g_menu',
    VIEW_DETAIL_G_MENU: 'view detail g_menu',
    CREATE_G_MENU: 'create g_menu',
    EDIT_G_MENU: 'edit g_menu',
    DELETE_G_MENU: 'delete g_menu',
    VIEW_ALL_G_SUBMENU: 'view all g_submenu',
    VIEW_DETAIL_G_SUBMENU: 'view detail g_submenu',
    CREATE_G_SUBMENU: 'create g_submenu',
    EDIT_G_SUBMENU: 'edit g_submenu',
    DELETE_G_SUBMENU: 'delete g_submenu',
    VIEW_ALL_PROVIDER_PAYMENT_SHEET: 'view all provider_payment_sheet',
    VIEW_DETAIL_PROVIDER_PAYMENT_SHEET: 'view detail provider_payment_sheet',
    CREATE_PROVIDER_PAYMENT_SHEET: 'create provider_payment_sheet',
    EDIT_PROVIDER_PAYMENT_SHEET: 'edit provider_payment_sheet',
    DELETE_PROVIDER_PAYMENT_SHEET: 'delete provider_payment_sheet',
    VIEW_ALL_PCH_PURCHASE_INVOICE_PAID: 'view all pch_purchase_invoice_paid',
    VIEW_ALL_PCH_PURCHASE_INVOICE_RECEIVE:
        'view all pch_purchase_invoice_receive',
    CREATE_PCH_PURCHASE_INVOICE: 'create pch_purchase_invoice',
    VIEW_ALL_PENDING_ACCOUNT_RECEIVABLE: 'view all pending_account_receivable',
    VIEW_ALL_CUSTOMER_RECEIVABLE_PAYMENT:
        'view all customer_receivable_payment',
    VIEW_DETAIL_CUSTOMER_RECEIVABLE_PAYMENT:
        'view detail customer_receivable_payment',
    CREATE_CUSTOMER_RECEIVABLE_PAYMENT: 'create customer_receivable_payment',
    EDIT_CUSTOMER_RECEIVABLE_PAYMENT: 'edit customer_receivable_payment',
    DELETE_CUSTOMER_RECEIVABLE_PAYMENT: 'delete customer_receivable_payment',
    VIEW_ALL_BANK_PAYMENT: 'view all bank_payment',
    VIEW_DETAIL_BANK_PAYMENT: 'view detail bank_payment',
    CREATE_BANK_PAYMENT: 'create bank_payment',
    EDIT_BANK_PAYMENTS: 'edit bank payments',
    DELETE_BANK_PAYMENT: 'delete bank_payment',
    VIEW_ALL_PURCHASE_TAX_DOCUMENT: 'view all purchase_tax_document',
    VIEW_DETAIL_PURCHASE_TAX_DOCUMENT: 'view detail purchase_tax_document',
    CREATE_PURCHASE_TAX_DOCUMENT: 'create purchase_tax_document',
    EDIT_PURCHASE_TAX_DOCUMENT: 'edit purchase_tax_document',
    DELETE_PURCHASE_TAX_DOCUMENT: 'delete purchase_tax_document',
    VIEW_ALL_SALE_DEBIT_NOTE: 'view all sale_debit_note',
    VIEW_DETAIL_SALE_DEBIT_NOTE: 'view detail sale_debit_note',
    CREATE_SALE_DEBIT_NOTE: 'create sale_debit_note',
    EDIT_SALE_DEBIT_NOTE: 'edit sale_debit_note',
    DELETE_SALE_DEBIT_NOTE: 'delete sale_debit_note',
    EXECUTE_MASSIVE_SEND_CUSTOMER_MAIL: 'execute massive send_customer_mail',
    VIEW_ALL_GROUND_SELLER: 'view all ground_seller',
    VIEW_DETAIL_GROUND_SELLER: 'view detail ground_seller',
    CREATE_GROUND_SELLER: 'create ground_seller',
    EDIT_GROUND_SELLER: 'edit ground_seller',
    DELETE_GROUND_SELLER: 'delete ground_seller',
    CREATE_FINANCE_CONTRACT: 'create finance_contract',
    VIEW_ALL_ACCOUNTING_RECORD: 'view all accounting_record',
    VIEW_DETAIL_ACCOUNTING_RECORD: 'view detail accounting_record',
    CREATE_ACCOUNTING_RECORD: 'create accounting_record',
    EDIT_ACCOUNTING_RECORD: 'edit accounting_record',
    DELETE_ACCOUNTING_RECORD: 'delete accounting_record',
    CREATE_FINANCE_ACCOUNTING_RECORD: 'create finance_accounting_record',
    VIEW_ALL_CASH_DESK: 'view all cash_desk',
    VIEW_DETAIL_CASH_DESK: 'view detail cash_desk',
    AUTHORIZE_OPEN_CASH_DESK: 'authorize open cash_desk',
    EXECUTE_CLOSE_CASH_DESK: 'execute close cash_desk',
    VIEW_ALL_CASH_MOVEMENT: 'view all cash_movement',
    VIEW_DETAIL_CASH_MOVEMENT: 'view detail cash_movement',
    CREATE_CASH_MOVEMENT: 'create cash_movement',
    VIEW_ALL_CASH_MOVEMENT_EGRESS_TYPE: 'view all cash_movement_egress_type',
    VIEW_DETAIL_CASH_MOVEMENT_EGRESS_TYPE:
        'view detail cash_movement_egress_type',
    VIEW_ALL_CASH_MOVEMENT_INGRESS_TYPE: 'view all cash_movement_ingress_type',
    VIEW_DETAIL_CASH_MOVEMENT_INGRESS_TYPE:
        'view detail cash_movement_ingress_type',
    AUTHORIZE_EGRESS_CASH_DESK: 'authorize egress cash_desk',
    AUTHORIZE_INGRESS_CASH_DESK: 'authorize ingress cash_desk',
    VIEW_ALL_DAILY_CASH: 'view all daily_cash',
    VIEW_DETAIL_DAILY_CASH: 'view detail daily_cash',
    VIEW_DETAIL_INITIAL_RESUME_DAILY_CASH:
        'view detail initial_resume_daily_cash',
    VIEW_DETAIL_COMPLETE_RESUME_DAILY_CASH:
        'view detail complete_resume_daily_cash',
    VIEW_ALL_EMPLOYEE_SALE: 'view all employee_sale',
    VIEW_DETAIL_EMPLOYEE_SALE: 'view detail employee_sale',
    EXECUTE_PAY_EMPLOYEE_SALE: 'execute pay employee_sale',
    VIEW_ALL_EMPLOYEE_SALE_PAYMENT_TYPE: 'view all employee_sale_payment_type',
    VIEW_DETAIL_EMPLOYEE_SALE_PAYMENT_TYPE:
        'view detail employee_sale_payment_type',
    AUTHORIZE_GENERATE_EMPLOYEE_SALE: 'authorize generate employee_sale',
    VIEW_ALL_INTERNAL_CONSUMPTION: 'view all internal_consumption',
    VIEW_DETAIL_INTERNAL_CONSUMPTION: 'view detail internal_consumption',
    VIEW_ALL_CUSTOMER_CREDIT_OPTION: 'view all customer_credit_option',
    VIEW_DETAIL_CUSTOMER_CREDIT_OPTION: 'view detail customer_credit_option',
    VIEW_ALL_SALE: 'view all sale',
    VIEW_DETAIL_SALE: 'view detail sale',
    EXECUTE_PAY_SALE: 'execute pay sale',
    EXECUTE_MASSIVE_PAY_MULTIPLE_SALE: 'execute massive pay multiple_sale',
    EXECUTE_CANCEL_SALE: 'execute cancel sale',
    EXECUTE_ACTIVATE_SALE: 'execute activate sale',
    ACCESS_TO_POINT_SALE: 'access_to point_sale',
    ACCESS_TO_CASH_DESK: 'access_to cash_desk',
    VIEW_ALL_SALE_PAYMENT_TYPE: 'view all sale_payment_type',
    VIEW_DETAIL_SALE_PAYMENT_TYPE: 'view detail sale_payment_type',
    VIEW_ALL_SALE_TYPE: 'view all sale_type',
    VIEW_DETAIL_SALE_TYPE: 'view detail sale_type',
    AUTHORIZE_SALE_BLOCKED_CUSTOMER: 'authorize sale blocked_customer',
    AUTHORIZE_TICKET_SALE: 'authorize ticket sale',
    AUTHORIZE_CHANGE_PRODUCT: 'authorize change product',
    AUTHORIZE_TICKET_OR_INVOICE: 'authorize ticket_or_invoice',
    VIEW_ALL_POS_SALE_NOTE: 'view all pos_sale_note',
    VIEW_DETAIL_POS_SALE_NOTE: 'view detail pos_sale_note',
    AUTHORIZE_GENERATE_CREDIT_NOTE: 'authorize generate credit_note',
    VIEW_ALL_RECEIVABLE_PAYMENT: 'view all receivable_payment',
    VIEW_DETAIL_RECEIVABLE_PAYMENT: 'view detail receivable_payment',
    CREATE_CUSTOMER_PAYMENT: 'create customer_payment',
    CREATE_GROUND_SELLER_PAYMENT: 'create ground_seller_payment',
    EXECUTE_CHANGE_TICKER_COUNTER: 'execute change ticker_counter',
    EXECUTE_CHANGE_VOUCHER_COUNTER: 'execute change voucher_counter',
    ACCESS_TO_POS_GROUND: 'access_to pos_ground',
    ACCESS_TO_POS_CALL_CENTER: 'access_to pos_call_center',
    VIEW_ALL_POS_DAILY_SALE_REPORT: 'view all pos_daily_sale_report',
    VIEW_DETAIL_POS_DAILY_SALE_REPORT: 'view detail pos_daily_sale_report',
    EXECUTE_CALCULATE_POS_DAILY_SALE_REPORT:
        'execute calculate pos_daily_sale_report',
    CREATE_POS_DAILY_SALE_REPORT: 'create pos_daily_sale_report',
    CREATE_AUTH_POS_DAILY_SALE_REPORT: 'create auth_pos_daily_sale_report',
    VIEW_DETAIL_POS_DAILY_SALE_REPORT_BY_DATE:
        'view detail pos_daily_sale_report_by_date',
    VIEW_ALL_PAYMENT_SHEET: 'view all payment_sheet',
    VIEW_DETAIL_PAYMENT_SHEET: 'view detail payment_sheet',
    CREATE_PAYMENT_SHEET: 'create payment_sheet',
    EDIT_PAYMENT_SHEET: 'edit payment_sheet',
    DELETE_PAYMENT_SHEET: 'delete payment_sheet',
    AUTHORIZE_VALID_PAYMENT_SHEET: 'authorize valid payment_sheet',
    EXECUTE_CONFIRM_PAY_PAYMENT_SHEET: 'execute confirm pay_payment_sheet',
    VIEW_ALL_PROVIDER_PAYMENT_SHEET_STATE:
        'view all provider_payment_sheet_state',
    VIEW_DETAIL_PROVIDER_PAYMENT_SHEET_STATE:
        'view detail provider_payment_sheet_state',
    VIEW_ALL_PURCHASE_QUOTATION: 'view all purchase_quotation',
    VIEW_DETAIL_PURCHASE_QUOTATION: 'view detail purchase_quotation',
    CREATE_PURCHASE_QUOTATION: 'create purchase_quotation',
    EDIT_PURCHASE_QUOTATION: 'edit purchase_quotation',
    DELETE_PURCHASE_QUOTATION: 'delete purchase_quotation',
    EXECUTE_SEND_MAIL_PURCHASE_QUOTATION:
        'execute send mail_purchase_quotation',
    VIEW_ALL_PURCHASE_PROVIDER_ACCOUNT_BANK:
        'view all purchase_provider_account_bank',
    VIEW_DETAIL_PURCHASE_PROVIDER_ACCOUNT_BANK:
        'view detail purchase_provider_account_bank',
    VIEW_ALL_PURCHASE_PROVIDER_ACCOUNT: 'view all purchase_provider_account',
    VIEW_DETAIL_PURCHASE_PROVIDER_ACCOUNT:
        'view detail purchase_provider_account',
    VIEW_ALL_PURCHASE_PROVIDER_ACCOUNT_MOVEMENT:
        'view all purchase_provider_account_movement',
    VIEW_DETAIL_PURCHASE_PROVIDER_ACCOUNT_MOVEMENT:
        'view detail purchase_provider_account_movement',
    VIEW_ALL_PURCHASE_TYPE_PROVIDER_ACCOUNT_MOVEMENT:
        'view all purchase_type_provider_account_movement',
    VIEW_DETAIL_PURCHASE_TYPE_PROVIDER_ACCOUNT_MOVEMENT:
        'view detail purchase_type_provider_account_movement',
    EDIT_PURCHASE_PROVIDER: 'edit purchase_provider',
    DELETE_PURCHASE_PROVIDER: 'delete purchase_provider',
    CREATE_RELATION_PURCHASE_PROVIDER_PRODUCT:
        'create relation purchase_provider_product',
    EDIT_PURCHASE_PROVIDER_BANK_ACCOUNT: 'edit purchase_provider_bank_account',
    VIEW_ALL_PURCHASE_PROVIDER: 'view all purchase_provider',
    VIEW_DETAIL_PURCHASE_PROVIDER: 'view detail purchase_provider',
    CREATE_PURCHASE_PROVIDER: 'create purchase_provider',
    VIEW_ALL_FINANCE_PROVIDER: 'view all finance_provider',
    VIEW_ALL_PURCHASE_PROVIDER_DEBT_TO_PAY:
        'view all purchase_provider_debt_to_pay',
    VIEW_DETAIL_PURCHASE_PROVIDER_DEBT_TO_PAY:
        'view detail purchase_provider_debt_to_pay',
    VIEW_ALL_PURCHASE_PROVIDER_PAYMENT: 'view all purchase_provider_payment',
    VIEW_DETAIL_PURCHASE_PROVIDER_PAYMENT:
        'view detail purchase_provider_payment',
    CREATE_PURCHASE_CREDIT_NOTE: 'create purchase_credit_note',
    VIEW_ALL_PURCHASE_DEBIT_NOTE: 'view all purchase_debit_note',
    VIEW_DETAIL_PURCHASE_DEBIT_NOTE: 'view detail purchase_debit_note',
    CREATE_PURCHASE_DEBIT_NOTE: 'create purchase_debit_note',
    EXECUTE_CHANGE_PAYABLE_PURCHASE_DEBIT_NOTE:
        'execute change payable_purchase_debit_note',
    VIEW_ALL_PURCHASE_INVOICE: 'view all purchase_invoice',
    VIEW_DETAIL_PURCHASE_INVOICE: 'view detail purchase_invoice',
    CREATE_PURCHASE_INVOICE: 'create purchase_invoice',
    EXECUTE_CHANGE_PAYABLE_PURCHASE_INVOICE:
        'execute change payable_purchase_invoice',
    VIEW_ALL_PAYMENT_CONDITION: 'view all payment_condition',
    VIEW_DETAIL_PAYMENT_CONDITION: 'view detail payment_condition',
    VIEW_ALL_PURCHASE_ORDER: 'view all purchase_order',
    VIEW_ALL_PENDING_PURCHASE_ORDER: 'view all pending_purchase_order',
    VIEW_ALL_EMITTED_PURCHASE_ORDER: 'view all emitted_purchase_order',
    VIEW_DETAIL_PURCHASE_ORDER: 'view detail purchase_order',
    CREATE_PURCHASE_ORDER: 'create purchase_order',
    VIEW_ALL_HISTORIC_PURCHASE_ORDER: 'view all historic_purchase_order',
    EDIT_PURCHASE_ORDER: 'edit purchase_order',
    DELETE_PURCHASE_ORDER: 'delete purchase_order',
    AUTHORIZE_VALID_PURCHASE_ORDER: 'authorize valid purchase_order',
    EXECUTE_RECEIVE_PURCHASE_ORDER: 'execute receive purchase_order',
    //
    VIEW_ALL_EDITED_PURCHASE_ORDER: 'view all edited_purchase_order',
    VIEW_DETAIL_EDITED_PURCHASE_ORDER: 'view detail edited_purchase_order',
    CREATE_EDITED_PURCHASE_ORDER: 'create edited_purchase_order',
    DELETE_EDITED_PURCHASE_ORDER: 'delete edited_purchase_order',
    AUTHORIZE_VALID_EDITED_PURCHASE_ORDER:
        'authorize valid edited_purchase_order',
    //
    VIEW_ALL_PURCHASE_ORDER_STATE: 'view all purchase_order_state',
    VIEW_DETAIL_PURCHASE_ORDER_DETAIL: 'view detail purchase_order_detail',
    VIEW_ALL_WAREHOUSE_ORDERER_UNPROCESSED:
        'view all warehouse_orderer_unprocessed',
    EXECUTE_BILL_DISPATCH_REQUEST: 'execute bill dispatch_request',
    VIEW_ALL_PURCHASE_TAX_DOCUMENT: 'view all purchase_tax_document',
    VIEW_DETAIL_PURCHASE_TAX_DOCUMENT: 'view detail purchase_tax_document',
    VIEW_ALL_SALE_INVOICE: 'view all sale_invoice',
    VIEW_DETAIL_SALE_INVOICE: 'view detail sale_invoice',
    VIEW_ALL_SALE_TICKET: 'view all sale_ticket',
    VIEW_DETAIL_SALE_TICKET: 'view detail sale_ticket',
    VIEW_DETAIL_DTE_BY_NUMBER: 'view detail dte_by_number',
    VIEW_ALL_ELECTRONIC_TRANSFER_PAYMENT:
        'view all electronic_transfer_payment',
    EXECUTE_CHANGE_TICKET_OR_INVOICE: 'execute change ticket_or_invoice',
    EXECUTE_CANCEL_TICKET_OR_INVOICE: 'execute cancel ticket_or_invoice',
    VIEW_ALL_SALE_TAX_DOCUMENT: 'view all sale_tax_document',
    VIEW_DETAIL_SALE_TAX_DOCUMENT: 'view detail sale_tax_document',
    VIEW_ALL_COMMISSION: 'view all commission',
    VIEW_DETAIL_COMMISSION: 'view detail commission',
    CREATE_COMMISSION: 'create commission',
    EDIT_COMMISSION: 'edit commission',
    DELETE_COMMISSION: 'delete commission',
    VIEW_ALL_COMMISSION_TYPE: 'view all commission_type',
    VIEW_DETAIL_COMMISSION_TYPE: 'view detail commission_type',
    VIEW_ALL_CUSTOMER_ACCOUNT_BANK: 'view all customer_account_bank',
    VIEW_DETAIL_CUSTOMER_ACCOUNT_BANK: 'view detail customer_account_bank',
    VIEW_ALL_CUSTOMER_ACCOUNT: 'view all customer_account',
    VIEW_DETAIL_CUSTOMER_ACCOUNT: 'view detail customer_account',
    VIEW_ALL_CUSTOMER_PURCHASE_HISTORY: 'view all customer_purchase_history',
    EXECUTE_MASSIVE_SEND_EMAIL_DEBT_CUSTOMER:
        'execute massive send email_debt_customer',
    VIEW_ALL_SLIM_CUSTOMER: 'view all slim customer',
    VIEW_ALL_TYPE_CUSTOMER_ACCOUNT_MOVEMENT:
        'view all type_customer_account_movement',
    VIEW_ALL_SALE_CUSTOMER: 'view all sale_customer',
    VIEW_DETAIL_SALE_CUSTOMER: 'view detail sale_customer',
    CREATE_SALE_CUSTOMER: 'create sale_customer',
    EDIT_SALE_CUSTOMER: 'edit sale_customer',
    DELETE_SALE_CUSTOMER: 'delete sale_customer',
    CREATE_FINANCE_CUSTOMER: 'create finance_customer',
    VIEW_DETAIL_TYPE_CUSTOMER_ACCOUNT_MOVEMENT:
        'view detail type_customer_account_movement',
    VIEW_ALL_FINANCE_CUSTOMER: 'view all finance_customer',
    VIEW_DETAIL_FINANCE_CUSTOMER: 'view detail finance_customer',
    EDIT_FINANCE_CUSTOMER: 'edit finance_customer',
    DELETE_FINANCE_CUSTOMER: 'delete finance_customer',
    VIEW_ALL_CUSTOMER_ACCOUNT_MOVEMENT: 'view all customer_account_movement',
    VIEW_DETAIL_CUSTOMER_ACCOUNT_MOVEMENT:
        'view detail customer_account_movement',
    VIEW_ALL_CUSTOMER_ACCOUNT_RECEIVABLE:
        'view all customer_account_receivable',
    VIEW_DETAIL_CUSTOMER_ACCOUNT_RECEIVABLE:
        'view detail customer_account_receivable',
    VIEW_ALL_CUSTOMER_PAYMENT: 'view all customer_payment',
    VIEW_DETAIL_CUSTOMER_PAYMENT: 'view detail customer_payment',
    VIEW_DETAIL_ELECTRONIC_TRANSFER_PAYMENT:
        'view detail electronic_transfer_payment',
    EXECUTE_IMPORT_BANK_CARD: 'execute import bank_card',
    CREATE_INVOICE_PAYMENT_VIA_BANK_CARD:
        'create invoice_payment_via_bank_card',
    VIEW_ALL_GROUND_SELLER_PAYMENT_RECORD:
        'view all ground_seller_payment_record',
    VIEW_DETAIL_GROUND_SELLER_PAYMENT_RECORD:
        'view detail ground_seller_payment_record',
    VIEW_ALL_CUSTOMER_PRESET_DISCOUNT: 'view all customer_preset_discount',
    VIEW_ALL_SALE_OFFER: 'view all sale_offer',
    VIEW_DETAIL_SALE_OFFER: 'view detail sale_offer',
    CREATE_SALE_OFFER: 'create sale_offer',
    EDIT_SALE_OFFER: 'edit sale_offer',
    DELETE_SALE_OFFER: 'delete sale_offer',
    VIEW_ALL_MASSIVE_SALE_OFFER: 'view all massive sale_offer',
    CREATE_MASSIVE_SALE_OFFER: 'create massive sale_offer',
    EDIT_MASSIVE_SALE_OFFER: 'edit massive sale_offer',
    DELETE_MASSIVE_SALE_OFFER: 'delete massive sale_offer',
    VIEW_ALL_WHOLESALE_DISCOUNT_BY_FAMILY:
        'view all wholesale_discount_by_family',
    CREATE_WHOLESALE_DISCOUNT_BY_FAMILY: 'create wholesale_discount_by_family',
    EDIT_WHOLESALE_DISCOUNT_BY_FAMILY: 'edit wholesale_discount_by_family',
    VIEW_ALL_WHOLESALE_DISCOUNT_BY_SUBFAMILY:
        'view all wholesale_discount_by_subfamily',
    CREATE_WHOLESALE_DISCOUNT_BY_SUBFAMILY:
        'create wholesale_discount_by_subfamily',
    EDIT_WHOLESALE_DISCOUNT_BY_SUBFAMILY:
        'edit wholesale_discount_by_subfamily',
    VIEW_ALL_WHOLESALE_DISCOUNT: 'view all wholesale_discount',
    VIEW_DETAIL_WHOLESALE_DISCOUNT: 'view detail wholesale_discount',
    CREATE_WHOLESALE_DISCOUNT: 'create wholesale_discount',
    EDIT_WHOLESALE_DISCOUNT: 'edit wholesale_discount',
    DELETE_WHOLESALE_DISCOUNT: 'delete wholesale_discount',
    VIEW_ALL_SALE_CREDIT_NOTE: 'view all sale_credit_note',
    VIEW_DETAIL_SALE_CREDIT_NOTE: 'view detail sale_credit_note',
    VIEW_ALL_PURCHASE_CREDIT_NOTE: 'view all purchase_credit_note',
    VIEW_DETAIL_PURCHASE_CREDIT_NOTE: 'view detail purchase_credit_note',
    EXECUTE_CHANGE_SALE_CREDIT_NOTE_COUNTER:
        'execute change sale_credit_note_counter',
    VIEW_ALL_SALE_DEBIT_NOTE: 'view all sale_debit_note',
    VIEW_DETAIL_SALE_DEBIT_NOTE: 'view detail sale_debit_note',
    CREATE_SALE_DEBIT_NOTE: 'create sale_debit_note',
    VIEW_ALL_SALE_QUOTATION: 'view all sale_quotation',
    VIEW_DETAIL_SALE_QUOTATION: 'view detail sale_quotation',
    CREATE_SALE_QUOTATION: 'create sale_quotation',
    EDIT_SALE_QUOTATION: 'edit sale_quotation',
    DELETE_SALE_QUOTATION: 'delete sale_quotation',
    VIEW_ALL_SALE_LIST_PRICE: 'view all sale_list_price',
    VIEW_DETAIL_SALE_LIST_PRICE: 'view detail sale_list_price',
    EDIT_SALE_LIST_PRICE: 'edit sale_list_price',
    VIEW_ALL_SERVICE_ORDER: 'view all service_order',
    VIEW_DETAIL_SERVICE_ORDER: 'view detail service_order',
    VIEW_ALL_SERVICE_ORDER_TYPE: 'view all service_order_type',
    VIEW_DETAIL_SERVICE_ORDER_TYPE: 'view detail service_order_type',
    VIEW_ALL_PRODUCT: 'view all product',
    VIEW_DETAIL_PRODUCT: 'view detail product',
    CREATE_PRODUCT: 'create product',
    EDIT_PRODUCT_LOGO: 'edit product_logo',
    EDIT_PRODUCT: 'edit product',
    DELETE_PRODUCT: 'delete product',
    VIEW_DETAIL_SUGGEST_UPC_CODE: 'view detail suggest_upc_code',
    VIEW_DETAIL_SUGGEST_INTERNAL_CODE: 'view detail suggest_internal_code',
    EDIT_MASSIVE_PRODUCT_MARGIN_PRICE: 'edit massive product_margin_price',
    VIEW_ALL_PRODUCT_MOVEMENT_REPORT: 'view all product_movement_report',
    VIEW_DETAIL_SLIM_PRODUCT_BY_ALIAS_NAME:
        'view detail slim product_by_alias_name',
    VIEW_ALL_PRODUCT_TAG: 'view all product_tag',
    VIEW_DETAIL_PRODUCT_TAG: 'view detail product_tag',
    CREATE_PRODUCT_TAG: 'create product_tag',
    EDIT_PRODUCT_TAG: 'edit product_tag',
    DELETE_PRODUCT_TAG: 'delete product_tag',
    VIEW_ALL_PRODUCT_FAMILY: 'view all product_family',
    VIEW_DETAIL_PRODUCT_FAMILY: 'view detail product_family',
    CREATE_PRODUCT_FAMILY: 'create product_family',
    EDIT_PRODUCT_FAMILY: 'edit product_family',
    DELETE_PRODUCT_FAMILY: 'delete product_family',
    VIEW_ALL_PRODUCT_SUBFAMILY: 'view all product_subfamily',
    VIEW_DETAIL_PRODUCT_SUBFAMILY: 'view detail product_subfamily',
    CREATE_PRODUCT_SUBFAMILY: 'create product_subfamily',
    EDIT_PRODUCT_SUBFAMILY: 'edit product_subfamily',
    DELETE_PRODUCT_SUBFAMILY: 'delete product_subfamily',
    VIEW_ALL_PRODUCT_PROMO: 'view all product_promo',
    VIEW_DETAIL_PRODUCT_PROMO: 'view detail product_promo',
    CREATE_PRODUCT_PROMO: 'create product_promo',
    EDIT_PRODUCT_PROMO: 'edit product_promo',
    VIEW_ALL_SELLER: 'view all seller',
    CREATE_SELLER: 'create seller',
    VIEW_ALL_CUSTOMER_PRESET_CHARGE: 'view all customer_preset_charge',
    EDIT_CUSTOMER_PRESET_CHARGE: 'edit customer_preset_charge',
    VIEW_DETAIL_CUSTOMER_PRESET_DISCOUNT:
        'view detail customer_preset_discount',
    VIEW_DETAIL_CUSTOMER_PRESET_CHARGE: 'view detail customer_preset_charge',
    VIEW_ALL_SALE_EDITED: 'view all sale_edited',
    VIEW_DETAIL_SALE_EDITED: 'view detail sale_edited',
    EDIT_POS_SALE: 'edit pos_sale',
    AUTHORIZE_CONFIRM_EDIT_POS_SALE: 'authorize confirm edit_pos_sale',
    VIEW_ALL_CONVERSION_FACTOR: 'view all conversion_factor',
    VIEW_DETAIL_CONVERSION_FACTOR: 'view detail conversion_factor',
    CREATE_CONVERSION_FACTOR: 'create conversion_factor',
    VIEW_ALL_UNIT_OF_MEASUREMENT: 'view all unit_of_measurement',
    VIEW_DETAIL_UNIT_OF_MEASUREMENT: 'view detail unit_of_measurement',
    EDIT_CONVERSION_FACTOR: 'edit conversion_factor',
    DELETE_CONVERSION_FACTOR: 'delete conversion_factor',
    VIEW_ALL_DISPATCH_GUIDE: 'view all dispatch_guide',
    VIEW_DETAIL_DISPATCH_GUIDE: 'view detail dispatch_guide',
    CREATE_DISPATCH_GUIDE: 'create dispatch_guide',
    EDIT_DISPATCH_GUIDE: 'edit dispatch_guide',
    DELETE_DISPATCH_GUIDE: 'delete dispatch_guide',
    VIEW_ALL_DISPATCH_ORDER: 'view all dispatch_order',
    VIEW_DETAIL_DISPATCH_ORDER: 'view detail dispatch_order',
    CREATE_DISPATCH_ORDER: 'create dispatch_order',
    EDIT_DISPATCH_ORDER: 'edit dispatch_order',
    DELETE_DISPATCH_ORDER: 'delete dispatch_order',
    VIEW_ALL_DISPATCH_REQUEST_BATCH: 'view all dispatch_request_batch',
    VIEW_DETAIL_DISPATCH_REQUEST_BATCH: 'view detail dispatch_request_batch',
    CREATE_DISPATCH_REQUEST_BATCH: 'create dispatch_request_batch',
    EDIT_DISPATCH_REQUEST_BATCH: 'edit dispatch_request_batch',
    VIEW_ALL_WAREHOUSE_MOVEMENT: 'view all warehouse_movement',
    VIEW_DETAIL_WAREHOUSE_MOVEMENT: 'view detail warehouse_movement',
    EXECUTE_DISPATCH_DISPATCH_REQUEST_BATCH:
        'execute dispatch dispatch_request_batch',
    EXECUTE_RECEIVE_DISPATCH_REQUEST_BATCH:
        'execute receive dispatch_request_batch',
    DELETE_DISPATCH_REQUEST_BATCH: 'delete dispatch_request_batch',
    VIEW_ALL_DISPATCH_REQUEST: 'view all dispatch_request',
    VIEW_DETAIL_DISPATCH_REQUEST: 'view detail dispatch_request',
    EDIT_DISPATCH_REQUEST: 'edit dispatch_request',
    DELETE_DISPATCH_REQUEST: 'delete dispatch_request',
    AUTHORIZE_CONFIRM_DISPATCH_REQUEST: 'authorize confirm dispatch_request',
    EXECUTE_BILL_DISPATCH_REQUEST: 'execute bill dispatch_request',
    VIEW_ALL_WAREHOUSE: 'view all warehouse',
    VIEW_DETAIL_WAREHOUSE: 'view detail warehouse',
    VIEW_ALL_PRODUCT_BY_WAREHOUSE: 'view all product_by_warehouse',
    CREATE_WAREHOUSE: 'create warehouse',
    EDIT_WAREHOUSE: 'edit warehouse',
    DELETE_WAREHOUSE: 'delete warehouse',
    VIEW_ALL_WAREHOUSE_ITEM: 'view all warehouse_item',
    VIEW_DETAIL_WAREHOUSE_ITEM: 'view detail warehouse_item',
    VIEW_ALL_WAREHOUSE_TYPE: 'view all warehouse_type',
    VIEW_DETAIL_WAREHOUSE_TYPE: 'view detail warehouse type',
    CREATE_WAREHOUSE_TYPE: 'create warehouse_type',
    EDIT_WAREHOUSE_TYPE: 'edit warehouse_type',
    DELETE_WAREHOUSE_TYPE: 'delete warehouse_type',
    VIEW_ALL_INVENTORY: 'view all inventory',
    VIEW_DETAIL_INVENTORY: 'view detail inventory',
    CREATE_INVENTORY: 'create inventory',
    EDIT_INVENTORY: 'edit inventory',
    EXECUTE_TAKE_INVENTORY: 'execute take inventory',
    AUTHORIZE_CONFIRM_INVENTORY: 'authorize confirm inventory',
    DELETE_INVENTORY: 'delete inventory',
    VIEW_ALL_MOVEMENT_INVENTORY: 'view all movement_inventory',
    VIEW_DETAIL_MOVEMENT_INVENTORY: 'view detail movement_inventory',
    EXECUTE_CANCELLED_INVENTORY: 'execute cancelled inventory',
    VIEW_ALL_STOCK_ADJUST: 'view all stock_adjust',
    VIEW_DETAIL_STOCK_ADJUST: 'view detail stock_adjust',
    CREATE_STOCK_ADJUST: 'create stock_adjust',
    EDIT_STOCK_ADJUST: 'edit stock_adjust',
    DELETE_STOCK_ADJUST: 'delete stock_adjust',
    VIEW_ALL_STOCK_ADJUST_TYPE: 'view all stock_adjust_type',
    VIEW_DETAIL_STOCK_ADJUST_TYPE: 'view detail stock_adjust_type',
    CREATE_STOCK_ADJUST_TYPE: 'create stock_adjust_type',
    EDIT_STOCK_ADJUST_TYPE: 'edit stock_adjust_type',
    DELETE_STOCK_ADJUST_TYPE: 'delete stock_adjust_type',
    VIEW_ALL_TRANSFER_BETWEEN_WAREHOUSE: 'view all transfer_between_warehouse',
    VIEW_DETAIL_TRANSFER_BETWEEN_WAREHOUSE:
        'view detail transfer_between_warehouse',
    CREATE_TRANSFER_BETWEEN_WAREHOUSE: 'create transfer_between_warehouse',
    EDIT_TRANSFER_BETWEEN_WAREHOUSE: 'edit transfer_between_warehouse',
    DELETE_TRANSFER_BETWEEN_WAREHOUSE: 'delete transfer_between_warehouse',
    EXECUTE_DISPATCH_TRANSFER_BETWEEN_WAREHOUSE:
        'execute dispatch transfer_between_warehouse',
    EXECUTE_RECEIVE_TRANSFER_BETWEEN_WAREHOUSE:
        'execute receive transfer_between_warehouse',
    VIEW_ALL_TRANSFER_BETWEEN_WAREHOUSE_STATE:
        'view all transfer_between_warehouse_state',
    VIEW_DETAIL_TRANSFER_BETWEEN_WAREHOUSE_STATE:
        'view detail transfer_between_warehouse_state',
    VIEW_ALL_PRODUCT_ITEM: 'view all product_item',
    VIEW_DETAIL_PRODUCT_ITEM: 'view detail product_item',
    CREATE_PRODUCT_ITEM: 'create product_item',
    EDIT_PRODUCT_ITEM: 'edit product_item',
    DELETE_PRODUCT_ITEM: 'delete product_item',
    VIEW_ALL_PRODUCT_ITEM_REPACKING: 'view all product_item_repacking',
    VIEW_ALL_PRODUCT_PACK: 'view all product_pack',
    VIEW_DETAIL_PRODUCT_PACK: 'view detail product_pack',
    CREATE_PRODUCT_PACK: 'create product_pack',
    EDIT_PRODUCT_PACK: 'edit product_pack',
    DELETE_PRODUCT_PACK: 'delete product_pack',
    VIEW_ALL_PRODUCT_PACKING: 'view all product_packing',
    VIEW_DETAIL_PRODUCT_PACKING: 'view detail product_packing',
    CREATE_PRODUCT_PACKING: 'create product_packing',
    EDIT_PRODUCT_PACKING: 'edit product_packing',
    DELETE_PRODUCT_PACKING: 'delete product_packing',
    VIEW_ALL_PRODUCT_REPACKING_HISTORIC: 'view all product_repacking_historic',
    CREATE_PRODUCT_REPACKING: 'create product_repacking',
    VIEW_DETAIL_PRODUCT_REPACKING_HISTORIC:
        'view detail product_repacking_historic',
    VIEW_ALL_WAREHOUSE_ORDERER: 'view all warehouse_orderer',
    VIEW_DETAIL_WAREHOUSE_ORDERER: 'view detail warehouse_orderer',
    CREATE_WAREHOUSE_ORDERER: 'create warehouse_orderer',
    CREATE_CRITICAL_WAREHOUSE_ORDERER: 'create critical_warehouse_orderer',
    EDIT_WAREHOUSE_ORDERER: 'edit warehouse_orderer',
    DELETE_WAREHOUSE_ORDERER: 'delete warehouse_orderer',
    VIEW_ALL_WAREHOUSE_ORDERER_PRIORITY: 'view all warehouse_orderer_priority',
    VIEW_ALL_WAREHOUSE_PURCHASE_ORDER: 'view all warehouse_purchase_order',
    EXECUTE_RECEIPT_WAREHOUSE_PURCHASE_ORDER:
        'execute receipt warehouse_purchase_order',
    VIEW_DETAIL_WAREHOUSE_ORDERER_PRIORITY:
        'view detail warehouse_orderer_priority',
    VIEW_ALL_PRODUCT_CRITICAL_NOTIFICATION:
        'view all product_critical_notification',
    VIEW_DETAIL_PRODUCT_CRITICAL_NOTIFICATION:
        'view detail product_critical_notification',
    VIEW_ALL_SALARY_SETTLEMENT: 'view all salary_settlement',
    VIEW_DETAIL_SALARY_SETTLEMENT: 'view detail salary_settlement',
    CREATE_SALARY_SETTLEMENT: 'create salary_settlement',
    EDIT_SALARY_SETTLEMENT: 'edit salary_settlement',
    AUTHORIZE_CONFIRM_SALARY_SETTLEMENT: 'authorize confirm salary_settlement',
    CREATE_SALARY_SETTLEMENT_ASSET_DISCOUNT:
        'create salary_settlement_asset_discount',
    VIEW_ALL_PAYROLL: 'view all payroll',
    VIEW_DETAIL_PAYROLL: 'view detail payroll',
    CREATE_PAYROLL: 'create payroll',
    EDIT_PAYROLL: 'edit payroll',
    DELETE_PAYROLL: 'delete payroll',
    AUTHORIZE_VALID_PAYROLL: 'authorize valid payroll',
    CREATE_PREVIRED_DATA_FROM_PAYROLL: 'create previred_data_from_payroll',
    EXECUTE_EXPORT_PREVIRED_CSV_FROM_PAYROLL:
        'execute export previred_csv_from_payroll',
    VIEW_ALL_HR_CONTRACT: 'view all hr_contract',
    VIEW_DETAIL_HR_CONTRACT: 'view detail hr_contract',
    CREATE_HR_CONTRACT: 'create hr_contract',
    EDIT_HR_CONTRACT: 'edit hr_contract',
    DELETE_HR_CONTRACT: 'delete hr_contract',
    EXECUTE_ACTIVATE_HR_CONTRACT: 'execute activate hr_contract',
    VIEW_ALL_FINIQUITO: 'view all finiquito',
    VIEW_DETAIL_FINIQUITO: 'view detail finiquito',
    CREATE_FINIQUITO: 'create finiquito',
    EDIT_FINIQUITO: 'edit finiquito',
    DELETE_FINIQUITO: 'delete finiquito',
    AUTHORIZE_VALID_FINIQUITO: 'authorize valid finiquito',
    EDIT_PREVISION_INDICATOR: 'edit prevision_indicator',
    VIEW_ALL_HR_ASSET_DISCOUNT: 'view all hr_asset_discount',
    VIEW_DETAIL_HR_ASSET_DISCOUNT: 'view detail hr_asset_discount',
    CREATE_HR_ASSET_DISCOUNT: 'create hr_asset_discount',
    EDIT_HR_ASSET_DISCOUNT: 'edit hr_asset_discount',
    DELETE_HR_ASSET_DISCOUNT: 'delete hr_asset_discount',
    VIEW_ALL_ABSENCE_REQUEST: 'view all absence_request',
    VIEW_DETAIL_ABSENCE_REQUEST: 'view detail absence_request',
    CREATE_ABSENCE_REQUEST: 'create absence_request',
    EDIT_ABSENCE_REQUEST: 'edit absence_request',
    DELETE_ABSENCE_REQUEST: 'delete absence_request',
    AUTHORIZE_CONFIRM_ABSENCE_REQUEST: 'authorize confirm absence_request',
    VIEW_ALL_HOLIDAY: 'view all holiday',
    VIEW_ALL_EMPLOYEE: 'view all employee',
    VIEW_DETAIL_EMPLOYEE: 'view detail employee',
    CREATE_EMPLOYEE: 'create employee',
    EDIT_EMPLOYEE: 'edit employee',
    DELETE_EMPLOYEE: 'delete employee',
    EXECUTE_ACTIVATE_EMPLOYEE: 'execute activate employee',
    VIEW_ALL_ISAPRE: 'view all isapre',
    VIEW_DETAIL_ISAPRE: 'view detail isapre',
    CREATE_ISAPRE: 'create isapre',
    EDIT_ISAPRE: 'edit isapre',
    DELETE_ISAPRE: 'delete isapre',
    VIEW_ALL_PREVISION: 'view all prevision',
    VIEW_DETAIL_PREVISION: 'view detail prevision',
    CREATE_PREVISION: 'create prevision',
    EDIT_PREVISION: 'edit prevision',
    DELETE_PREVISION: 'delete prevision',
    VIEW_ALL_PREVISION_INDICATOR: 'view all prevision_indicator',
    VIEW_DETAIL_PREVISION_INDICATOR: 'view detail prevision_indicator',
    CREATE_EMPLOYEE_FAMILY_BURDEN: 'create employee_family_burden',
    DELETE_EMPLOYEE_FAMILY_BURDEN: 'delete employee_family_burden',
    EDIT_COMPANY_MUTUAL_DATA: 'edit company_mutual_data',
    EDIT_COMPANY_CCAF_DATA: 'edit company_ccaf_data',
    VIEW_ALL_PURCHASE_SALE_BOOK: 'view all purchase_sale_book',
    VIEW_DETAIL_PURCHASE_SALE_BOOK: 'view detail purchase_sale_book',
    CREATE_PURCHASE_SALE_BOOK: 'create purchase_sale_book',
    EXECUTE_REVIEW_PURCHASE_SALE_BOOK: 'execute review purchase_sale_book',
    DELETE_PURCHASE_SALE_BOOK: 'delete purchase_sale_book',
    EXECUTE_MASSIVE_CHANGE_DOCUMENT_ACCOUNTING_DATE:
        'execute massive change document_accounting_date',
    VIEW_ALL_COST_CENTER: 'view all cost_center',
    VIEW_DETAIL_COST_CENTER: 'view detail cost_center',
    CREATE_COST_CENTER: 'create cost_center',
    EDIT_COST_CENTER: 'edit cost_center',
    DELETE_COST_CENTER: 'delete cost_center',
    VIEW_ALL_ACCOUNTING_PURCHASE_DOCUMENT:
        'view all accounting_purchase_document',
    VIEW_DETAIL_ACCOUNTING_PURCHASE_DOCUMENT:
        'view detail accounting_purchase_document',
    CREATE_ACCOUNTING_PURCHASE_DOCUMENT: 'create accounting_purchase_document',
    EDIT_ACCOUNTING_PURCHASE_DOCUMENT: 'edit accounting_purchase_document',
    DELETE_ACCOUNTING_PURCHASE_DOCUMENT: 'delete accounting_purchase_document',
    VIEW_ALL_ACCOUNTING_SALE_DOCUMENT: 'view all accounting_sale_document',
    VIEW_DETAIL_ACCOUNTING_SALE_DOCUMENT:
        'view detail accounting_sale_document',
    CREATE_ACCOUNTING_SALE_DOCUMENT: 'create accounting_sale_document',
    EDIT_ACCOUNTING_SALE_DOCUMENT: 'edit accounting_sale_document',
    DELETE_ACCOUNTING_SALE_DOCUMENT: 'delete accounting_sale_document',
    VIEW_ALL_ACCOUNTING_DAILY_LEDGER: 'view all accounting_daily_ledger',
    VIEW_DETAIL_ACCOUNTING_DAILY_LEDGER: 'view detail accounting_daily_ledger',
    CREATE_ACCOUNTING_DAILY_LEDGER: 'create accounting_daily_ledger',
    EDIT_ACCOUNTING_DAILY_LEDGER: 'edit accounting_daily_ledger',
    DELETE_ACCOUNTING_DAILY_LEDGER: 'delete accounting_daily_ledger',
    EXECUTE_EXPORT_ACCOUNTING_DAILY_LEDGER:
        'execute export accounting_daily_ledger',
    VIEW_ALL_ACCOUNTING_LEDGER: 'view all accounting_ledger',
    VIEW_DETAIL_ACCOUNTING_LEDGER: 'view detail accounting_ledger',
    CREATE_ACCOUNTING_LEDGER: 'create accounting_ledger',
    DELETE_ACCOUNTING_LEDGER: 'delete accounting_ledger',
    VIEW_ALL_ACCOUNT: 'view all account',
    VIEW_DETAIL_ACCOUNT: 'view detail account',
    CREATE_ACCOUNT: 'create account',
    EDIT_ACCOUNT: 'edit account',
    DELETE_ACCOUNT: 'delete account',
    VIEW_ALL_ACCOUNT_TYPE: 'view all account_type',
    VIEW_DETAIL_ACCOUNT_TYPE: 'view detail account_type',
    VIEW_ALL_ACCOUNTING_SEAT: 'view all accounting_seat',
    VIEW_DETAIL_ACCOUNTING_SEAT: 'view detail accounting_seat',
    CREATE_ACCOUNTING_SEAT: 'create accounting_seat',
    EDIT_ACCOUNTING_SEAT: 'edit accounting_seat',
    DELETE_ACCOUNTING_SEAT: 'delete accounting_seat',
    AUTHORIZE_CONFIRM_ACCOUNTING_SEAT: 'authorize confirm accounting_seat',
    VIEW_ALL_ACCOUNTING_SEAT_STATUS: 'view all accounting_seat_status',
    VIEW_DETAIL_ACCOUNTING_SEAT_STATUS: 'view detail accounting_seat_status',
    VIEW_ALL_ACCOUNTING_SEAT_TYPE: 'view all accounting_seat_type',
    VIEW_DETAIL_ACCOUNTING_SEAT_TYPE: 'view detail accounting_seat_type',
    VIEW_ALL_ACCOUNTING_SEAT_CONCEPTS: 'view all accounting_seat_concepts',
    VIEW_DETAIL_ACCOUNTING_SEAT_CONCEPT: 'view detail accounting_seat_concept',
    CREATE_ACCOUNTING_SEAT_CONCEPT: 'create accounting_seat_concept',
    EDIT_ACCOUNTING_SEAT_CONCEPT: 'edit accounting_seat_concept',
    DELETE_ACCOUNTING_SEAT_CONCEPT: 'delete accounting_seat_concept',
    VIEW_ALL_ACCOUNT_BANK_CONCILIATION: 'view all account_bank_conciliation',
    VIEW_DETAIL_ACCOUNT_BANK_CONCILIATION:
        'view detail account_bank_conciliation',
    CREATE_ACCOUNT_BANK_CONCILIATION: 'create account_bank_conciliation',
    EDIT_ACCOUNT_BANK_CONCILIATION: 'edit account_bank_conciliation',
    DELETE_ACCOUNT_BANK_CONCILIATION: 'delete account_bank_conciliation',
    CREATE_RELATION_BANK_ACCOUNT_CONCILIATION:
        'create relation bank_account_conciliation',
    DELETE_BANK_ACCOUNT_CONCILIATION: 'delete bank_account_conciliation',
    VIEW_ALL_ACCOUNTING_NOTE: 'view all accounting_note',
    VIEW_DETAIL_ACCOUNTING_NOTE: 'view detail accounting_note',
    CREATE_ACCOUNTING_NOTE: 'create accounting_note',
    EDIT_ACCOUNTING_NOTE: 'edit accounting_note',
    DELETE_ACCOUNTING_NOTE: 'delete accounting_note',
    VIEW_ALL_TEMPLATE_ACCOUNTING_SEAT_TYPE:
        'view all template_accounting_seat_type',
    VIEW_DETAIL_TEMPLATE_ACCOUNTING_SEAT_TYPE:
        'view detail template_accounting_seat_type',
    EDIT_TEMPLATE_ACCOUNTING_SEAT_TYPE: 'edit template accounting_seat_type',
    EXECUTE_EXPORT_EIGHT_COLUMNS_BALANCE_EXCEL:
        'execute export eight_columns_balance_excel',
    VIEW_ALL_EIGHT_COLUMNS_BALANCE: 'view all eight_columns_balance',
    CREATE_USER: 'create user',
    EDIT_USER: 'edit user',
    DELETE_USER: 'delete user',
    MENU_INVENTORY_VIEW_ALL_PRODUCT: 'menu inventory view all product',
    MENU_INVENTORY_VIEW_ALL_WAREHOUSE_ORDERER:
        'menu inventory view all warehouse_orderer',
    MENU_INVENTORY_VIEW_ALL_CRITICAL_WAREHOUSE_ORDERER:
        'menu inventory view all critical_warehouse_orderer',
    MENU_INVENTORY_VIEW_ALL_MOVEMENT_INVENTORY:
        'menu inventory view all movement_inventory',
    MENU_INVENTORY_VIEW_ALL_TRANSFER_BETWEEN_WAREHOUSE:
        'menu inventory view all transfer_between_warehouse',
    MENU_INVENTORY_VIEW_ALL_PURCHASE_ORDER:
        'menu inventory view all purchase_order',
    MENU_INVENTORY_VIEW_ALL_INVENTORY: 'menu inventory view all inventory',
    MENU_INVENTORY_VIEW_ALL_STOCK_ADJUST:
        'menu inventory view all stock_adjust',
    MENU_INVENTORY_VIEW_ALL_WAREHOUSE: 'menu inventory view all warehouse',
    MENU_INVENTORY_VIEW_ALL_PRODUCT_BY_WAREHOUSE:
        'menu inventory view all product_by_warehouse',
    MENU_INVENTORY_VIEW_ALL_DISPATCH_REQUEST:
        'menu inventory view all dispatch_request',
    MENU_INVENTORY_VIEW_ALL_DISPATCH_REQUEST_BATCH:
        'menu inventory view all dispatch_request_batch',
    MENU_INVENTORY_VIEW_ALL_REPACKING_HISTORIC:
        'menu inventory view all repacking_historic',
    MENU_INVENTORY_VIEW_ALL_PURCHASE_PROVIDER:
        'menu inventory view all purchase_provider',
    MENU_ACQUISITION_VIEW_ALL_WAREHOUSE_ORDERER_UNPROCESSED:
        'menu acquisition view all warehouse_orderer_unprocessed',
    MENU_ACQUISITION_VIEW_ALL_PURCHASE_QUOTATION:
        'menu acquisition view all purchase_quotation',
    MENU_ACQUISITION_VIEW_ALL_PURCHASE_ORDER:
        'menu acquisition view all purchase_order',
    MENU_ACQUISITION_VIEW_ALL_PENDING_PURCHASE_ORDER:
        'menu acquisition view all pending_purchase_order',
    MENU_ACQUISITION_VIEW_ALL_EMITTED_PURCHASE_ORDER:
        'menu acquisition view all emitted_purchase_order',
    MENU_ACQUISITION_VIEW_ALL_PURCHASE_PROVIDER:
        'menu acquisition view all purchase_provider',
    MENU_ACQUISITION_VIEW_ALL_PURCHASE_INVOICE:
        'menu acquisition view all purchase_invoice',
    MENU_ACQUISITION_VIEW_ALL_WAREHOUSE_ORDERER_HISTORIC:
        'menu acquisition view all warehouse_orderer_historic',
    MENU_ACQUISITION_VIEW_ALL_PURCHASE_ORDER_HISTORIC:
        'menu acquisition view all purchase_order_historic',
    MENU_FINANCE_VIEW_ALL_PROVIDER_PAYMENT_SHEET:
        'menu finance view all provider_payment_sheet',
    MENU_FINANCE_VIEW_ALL_PURCHASE_INVOICE_PAID:
        'menu finance view all purchase_invoice_paid',
    MENU_FINANCE_VIEW_ALL_PURCHASE_INVOICE_RECEIVE:
        'menu finance view all purchase_invoice_receive',
    MENU_FINANCE_VIEW_ALL_PURCHASE_PROVIDER:
        'menu finance view all purchase_provider',
    MENU_FINANCE_VIEW_ALL_PURCHASE_TAX_DOCUMENT:
        'menu finance view all purchase_tax_document',
    MENU_FINANCE_VIEW_ALL_SALE_DEBIT_NOTE:
        'menu finance view all sale_debit_note',
    MENU_FINANCE_VIEW_ALL_CUSTOMER: 'menu finance view all customer',
    MENU_FINANCE_VIEW_ALL_GROUND_SELLER: 'menu finance view all ground_seller',
    MENU_FINANCE_VIEW_ALL_PENDING_ACCOUNT_RECEIVABLE:
        'menu finance view all pending_account_receivable',
    MENU_FINANCE_VIEW_ALL_MASSIVE_CUSTOMER_MAIL:
        'menu finance view all massive customer_mail',
    MENU_FINANCE_VIEW_ALL_CUSTOMER_RECEIVABLE_PAYMENT:
        'menu finance view all customer_receivable_payment',
    MENU_FINANCE_VIEW_ALL_BANK_PAYMENT: 'menu finance view all bank_payment',
    MENU_FINANCE_VIEW_ALL_EMPLOYEE: 'menu finance view all employee',
    MENU_FINANCE_VIEW_ALL_CONTRACT: 'menu finance view all contract',
    MENU_FINANCE_VIEW_ALL_ASSET_DISCOUNT:
        'menu finance view all asset_discount',
    MENU_FINANCE_VIEW_ALL_PAYROLL: 'menu finance view all payroll',
    MENU_FINANCE_VIEW_ALL_SALARY_SETTLEMENT:
        'menu finance view all salary_settlement',
    MENU_FINANCE_VIEW_ALL_ABSENCE_REQUEST:
        'menu finance view all absence_request',
    MENU_FINANCE_VIEW_ALL_HOLIDAY: 'menu finance view all holiday',
    MENU_FINANCE_VIEW_ALL_FINIQUITO: 'menu finance view all finiquito',
    MENU_FINANCE_VIEW_ALL_ISAPRE: 'menu finance view all isapre',
    MENU_FINANCE_VIEW_ALL_PREVISION: 'menu finance view all prevision',
    MENU_FINANCE_VIEW_ALL_PREVISION_INDICATOR:
        'menu finance view all prevision_indicator',
    MENU_FINANCE_VIEW_ALL_ACCOUNT: 'menu finance view all account',
    MENU_FINANCE_VIEW_ALL_ACCOUNT_RECORD:
        'menu finance view all account_record',
    MENU_FINANCE_VIEW_ALL_ACCOUNTING_NOTE:
        'menu finance view all accounting_note',
    MENU_FINANCE_VIEW_ALL_BANK_CONCILIATION:
        'menu finance view all bank_conciliation',
    MENU_FINANCE_VIEW_ALL_COST_CENTER: 'menu finance view all cost_center',
    MENU_FINANCE_VIEW_ALL_CONT_PURCHASE_DOCUMENT:
        'menu finance view all cont_purchase_document',
    MENU_FINANCE_VIEW_ALL_CONT_SALE_DOCUMENT:
        'menu finance view all cont_sale_document',
    MENU_FINANCE_VIEW_ALL_DAILY_LEDGER: 'menu finance view all daily_ledger',
    MENU_FINANCE_VIEW_ALL_EIGHT_COLUMN_BALANCE:
        'menu finance view all eight_column_balance',
    MENU_FINANCE_VIEW_ALL_LEDGER: 'menu finance view all ledger',
    MENU_FINANCE_VIEW_ALL_PURCHASE_SALE_BOOK:
        'menu finance view all purchase_sale_book',
    MENU_SALE_VIEW_ALL_PRODUCT: 'menu sale view all product',
    MENU_SALE_VIEW_ALL_PRODUCT_PROMO: 'menu sale view all product_promo',
    MENU_SALE_VIEW_ALL_EDIT_SALE_PRICE: 'menu sale view all edit_sale_price',
    MENU_SALE_VIEW_ALL_CUSTOMER: 'menu sale view all customer',
    MENU_SALE_VIEW_ALL_PRODUCT_TAG: 'menu sale view all product_tag',
    MENU_SALE_VIEW_ALL_PRODUCT_FAMILY: 'menu sale view all product_family',
    MENU_SALE_VIEW_ALL_MASSIVE_OFFER: 'menu sale view all massive offer',
    MENU_SALE_VIEW_ALL_COMMISSION: 'menu sale view all commission',
    MENU_SALE_VIEW_ALL_SELLER: 'menu sale view all seller',
    MENU_CASH_VIEW_ALL_CASH: 'menu cash view all cash',
}
